import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE } from "../../config/RoutesConstants"
import { 
  Box, 
  Button,
  Chip,
  Fab,
  IconButton,
  Paper,
  Typography, 
  Tooltip,
  Table,
  TableRow,
  TableCell,
  TableSortLabel,
  TableHead,
  TableBody,
  TablePagination

} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"

import Util, { WARNING, ERROR, SUCCESS, handleSubmitFail } from '../../common/Util'
import { DUMMY_EVENT_DNI } from '../../common/Constants'
import { actionGetStatsByClient, actionExportStatsByClient } from "../../actions/StatsActions"
import { actionGetUsersByEmailOrDU } from "../../actions/UserActions";

import moment from "moment"
// import ClearIcon from '@material-ui/icons/Backspace';
import DetailIcon from '@material-ui/icons/List';
import ExcelIcon from "@material-ui/icons/CloudDownload";
import UserInfoDialog from "../../components/Dialog/UserInfoDialog"
import StatsFilterToolbar from './StatsFilterToolbar'

let _handleSubmitFail;
class StatsByClientTab extends React.PureComponent{
  constructor(props){
    super(props)
    this.state = {count:0, rowPerPage:10, page:1, orderBy:"Qt", orderDesc:true, tabIndex:0, filter:{}, userDialogInformation:false, userDialogInformationUser:{}}
    _handleSubmitFail=this.handleSubmitFail.bind(this)
    this.renderTableHeader=this.renderTableHeader.bind(this)
    this.renderTableBody=this.renderTableBody.bind(this)
    this.onRefresh = this.onRefresh.bind(this)
    this.sortStatsByClient = this.sortStatsByClient.bind(this)
    this.onChangePage = this.onChangePage.bind(this)
    this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this)
    this.onSortByField = this.onSortByField.bind(this)
    this.onPressUserInformation = this.onPressUserInformation.bind(this)
    this.onSearch = this.onSearch.bind(this)
    this.onExport = this.onExport.bind(this)
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);      
    }else{
      let lastMonth = moment()
      lastMonth = lastMonth.add(-1,"month").format("YYYY-MM-DD")
      const today = moment().format("YYYY-MM-DD")
      const filter = {from:lastMonth, to:today, period:"daily", place:"", state:"", onlyGift:false, user: ""}
      this.onRefresh(filter)
    }
  }

  getStatsByClientError(e){
    console.log("ERROR GET STATS BY CLIENT", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al listar las estadísticas por cliente.")
  }
  
  handleSubmitFail(error){
    console.log("ERROR EN EL SUBMIT", error)
  }

  onRefresh(filter){
    const {orderBy, orderDesc} = this.state
    this.setState({filter:filter})
    let order = {orderBy:orderBy, orderDesc:orderDesc}
    this.props.actionGetStatsByClient(filter, order, this.onChangePage, this.getStatsByClientError)
  }

  onSortByField(field){
    if(field == this.state.orderBy){
      this.setState({orderDesc:!this.state.orderDesc}, this.onChangePage)
    }else{
      this.setState({orderBy:field}, this.onChangePage)
    }
  }

  onExport(){
    const {filter, orderBy, orderDesc} = this.state
    let order = {orderBy:orderBy, orderDesc:orderDesc}
    console.log("EXPORT")
    this.props.actionExportStatsByClient(filter, order, (response) => {
      console.log("EXPORTADO", response)
      setTimeout(() => {
        window.open(response, '_self');
      }, 200);
    },
    (e)=>{
      if (!(e && e.status && e.status == 401))
      Util.showNoty(ERROR, "Ocurrió un error al exportar las estadísticas por cliente.");
    })
  }


  onChangePage(evt=null, newPage=0){
    let from=newPage*this.state.rowPerPage
    let end=from+this.state.rowPerPage
    let users = this.props.statsByClient //.filter(this.filterUsers)
    const count = users.length
    users = users.sort(this.sortStatsByClient)
    users = users.slice(from, end)
    this.setState({page:newPage, count:count, users:users})
  }

  onChangeRowsPerPage(evt){
    let from=this.state.page*evt.target.value
    let end=from+evt.target.value
    let users = this.props.statsByClient //.filter(this.filterUsers)
    const count = users.length
    users = users.sort(this.sortStatsByClient)
    users = users.slice(from, end)
    this.setState({rowPerPage:evt.target.value, users:users})
  }

  sortStatsByClient(a,b){
    try{
      if(this.state.orderDesc){
        return b[this.state.orderBy] - a[this.state.orderBy]
      }
      return a[this.state.orderBy] - b[this.state.orderBy]
    }catch(e){
      console.log("SORT STATS BY CLIENT ERROR", e)
      return -1
    }
  }

  onChangeFilter(field, evt){
    let filter = {...this.state.filter}
    filter[field] = field=="onlyGift"?evt.target.checked:evt.target.value
    this.setState({filter:filter})
  }
  
  
  onPressUserInformation(item) {
    const { tktBuyerDU, tktBuyerEmail, tktOwnerDU, tktOwnerEmail } = item;
    this.props.actionGetUsersByEmailOrDU(
      tktBuyerDU == DUMMY_EVENT_DNI ? tktOwnerDU:tktBuyerDU,
      tktBuyerDU == DUMMY_EVENT_DNI ? tktOwnerEmail:tktBuyerEmail,
      (data) => {
        if (data && data.users && data.users.length > 0) {
          this.setState({
            userDialogInformation: true,
            userDialogInformationUser: data.users[0],
          });
        } else {
          Util.showNoty(WARNING, "No encontramos el usuario");
        }
      },
      (e) => {
        Util.showNoty(ERROR, "No se encontró el usuario.");
      }
    );
  }

  renderTableHeader(){
    const {theme} = this.props
    const headers = [{id:"tktBuyerLastName",label:"Apellido y Nombre"}, 
                     {id:"tktBuyerDU",label:"DNI"},
                     {id:"Qt", label:"Cantidad"},
                     {id:"Total", label:"Total $"},
                     {id:"TotalProducer", label:"Total $ Productor"}]             
    // if(Settings.IS_USER_VERIFIED){
    //   headers.splice(1,0,{id:"proInstagram",label:"Instagram"})

    // }
    return (
    <TableRow>
      {headers.map((headCell,i)=>{
        if(headCell.id == "tktBuyerDU"||headCell.id == "tktBuyerLastName"){
          return (
            <TableCell> {headCell.label}</TableCell>
          )
        }
        return (
          <TableCell>
            <TableSortLabel
            active={this.state.orderBy === headCell.id}
            direction={this.state.orderBy === headCell.id && this.state.orderDesc ? 'desc' : 'asc'}
            onClick={()=>this.onSortByField(headCell.id)}
            hideSortIcon={true}>
              {headCell.label}
            </TableSortLabel>  
          </TableCell>
        )
      })}
      <TableCell style={theme.table.actionsColumn}>Acciones</TableCell>
    </TableRow>
    )
  }

  renderTableBody(){
    const {theme, onPressDetail} = this.props
    let users = this.state.users
    if(!users||users.length==0){
      return <Box style={theme.table.empty}>No se encontraron registros</Box>
    }
 
    return users.map((item, index)=>{
      return (
        <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          {/* {Settings.IS_USER_VERIFIED&&<TableCell>{item.proInstagram}</TableCell>} */}
         <TableCell>
            {/* <Tooltip title={item.tktOwnerEmail}> */}
            <Box>
              <Button
                style={{ backgroundColor: "aquamarine" }}
                onClick={() => this.onPressUserInformation(item)}
              >
                <Typography variant="body">
                  {`${item.tktBuyerLastName}, ${item.tktBuyerName}`}
                </Typography>
              </Button>
              <Box>
              {item.proTags &&
                item.proTags.map((t) => (
                  <Chip
                    size="small"
                    label={t.tagName}
                    style={{ backgroundColor: t.tagColor, color:theme.palette.getContrastText(t.tagColor), fontSize:10 }}
                  />
                ))}
              </Box>
            </Box>
            {/* </Tooltip> */}
          </TableCell>
          <TableCell>{item.tktBuyerDU}</TableCell>
          <TableCell>{item.Qt}</TableCell>
          <TableCell>{Util.formatCurrency(item.Total)}</TableCell>
          <TableCell>{Util.formatCurrency(item.TotalProducer)}</TableCell>
          <TableCell style={theme.table.actionsColumn}>
            <Tooltip title="Ver Detalle">
              <IconButton onClick={()=>onPressDetail(item, this.state.filter)}>
                <DetailIcon/>
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      )
    })
  }
  
  onSearch(filter){
    console.log("FILTER", filter)
    if(filter&&filter.from&&filter.to){
      this.onRefresh(filter)
    }
  }

  render(){
    const { theme, handleSubmit, history, placeList, tagList} = this.props
    return (
        <Paper style={theme.paper.form}>
          <Box style={{textAlign:"end"}}>
            <Tooltip title="Descargar listado de estadísticas por clientes">
              <Fab
                onClick={this.onExport}
                size="small"
                style={{ marginLeft: 16, width: 34, height: 34 }}
                color="secondary"
              >
                <ExcelIcon size="small" />
              </Fab>
            </Tooltip>
          </Box>
          <StatsFilterToolbar onSearch={this.onSearch} placeList={placeList} tagList={tagList}/>
          <Table stickyHeader>
            <TableHead > 
              {this.renderTableHeader()}
            </TableHead>
            <TableBody>
              {this.renderTableBody()}
            </TableBody>
          </Table> 
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 100]}
            component="div"
            count={this.state.count}
            rowsPerPage={this.state.rowPerPage}
            page={this.state.page}
            onChangePage={this.onChangePage}
            onChangeRowsPerPage={this.onChangeRowsPerPage}
          />
          <UserInfoDialog open={this.state.userDialogInformation} user={this.state.userDialogInformationUser} onClose={()=>{this.setState({userDialogInformation:false, userDialogInformationUser:{}})}}/>
        </Paper>
    )
  }
}
function mapStateToProps(store) {
  return {
    login: store.auth.login,
    statsByClient:store.stats.statsByClient,
    placeList: store.plc.placeList,
    tagList: store.tag.tagList     
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetStatsByClient,
      actionGetUsersByEmailOrDU,
      actionExportStatsByClient    
    },
    dispatch
  );
}

// StatsByClientTab.defaultProps = {
//   stats:{
//     statsTotalQtSell:50,
//     statsTotalQt:1000,
//     statsTotalAmmountProducer:22000,
//     statsTotalAmmount:27000,
//     statsTotalQtSellByRRPP:1100 //transient
//   }
// }

export default withRouter(
    withTheme(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(StatsByClientTab)
    )
  )


// WEBPACK FOOTER //
// ./src/screens/statistics/StatsByClientTab.js